import { render } from "./WIPView.vue?vue&type=template&id=e98b5cbe&scoped=true"
const script = {}

import "./WIPView.vue?vue&type=style&index=0&id=e98b5cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98b5cbe"]])

export default __exports__